export const getUser = () => {

    const user =
        localStorage.getItem("user");

    return user
        ? JSON.parse(user)
        : null;

};



export const hasPermission = (
    permission
) => {


    const user = getUser();


    if (!user)
        return false;



    const permissions =
        user.permissions || [];



    return permissions.includes(
        permission
    );



};